export const TIMELINE_START_HOUR = 6
export const TIMELINE_END_HOUR = 20
export const TIMELINE_DURATION_MINUTES = (TIMELINE_END_HOUR - TIMELINE_START_HOUR) * 60
export const SNAP_MINUTES = 15
export const MIN_WORK_DURATION = 15

export const TIMELINE_HOURS = Array.from(
  { length: TIMELINE_END_HOUR - TIMELINE_START_HOUR },
  (_, i) => TIMELINE_START_HOUR + i,
)

export function getLeftPercent(dateIso: string): number {
  const date = new Date(dateIso)
  const minuteOfDay = date.getHours() * 60 + date.getMinutes()
  const offset = minuteOfDay - TIMELINE_START_HOUR * 60
  return Math.max(0, Math.min(100, (offset / TIMELINE_DURATION_MINUTES) * 100))
}

export function getWidthPercent(durationMinutes: number): number {
  return Math.max(0, Math.min(100, (durationMinutes / TIMELINE_DURATION_MINUTES) * 100))
}

export function formatHour(hour: number): string {
  return `${String(hour).padStart(2, '0')}:00`
}

export function getDateIsoFromXPercent(xPercent: number, dayIso: string): string {
  const base = new Date(dayIso)
  const rawMinutes = (Math.max(0, Math.min(100, xPercent)) / 100) * TIMELINE_DURATION_MINUTES
  const snappedMinutes = Math.round(rawMinutes / 15) * 15
  return new Date(
    base.getFullYear(), base.getMonth(), base.getDate(),
    TIMELINE_START_HOUR, snappedMinutes, 0, 0,
  ).toISOString()
}
